import { render } from "./LienVIPCreateForm.vue?vue&type=template&id=0a9483a6"
import script from "./LienVIPCreateForm.vue?vue&type=script&lang=js"
export * from "./LienVIPCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__